module.exports = __webpack_public_path__ + "static/dragonborn-paladin-redclay-AYAGWW-f6d11c3b893bee9f093fd90d607f5f48.png";